export enum UserType {
  Admin = 'Admin',
  Creator = 'Creator',
  Uploader = 'Uploader',
  Controller = 'Controller',
  Speaker = 'Speaker',
  SuperManager = 'SuperManager',
  Manager = 'Manager'
}
